// src/services/dashboardService.ts
import apiClient from './apiClient';
import { DashboardMetrics, DashboardGrowth, UserProfile } from '../types/dashboard';

const METRICS_PATH = 'dashboard/metrics';
const GROWTH_PATH = 'dashboard/growth';
const PROFILE_PATH = 'profile';

const getMetrics = async (): Promise<DashboardMetrics> => {
  const response = await apiClient.get(METRICS_PATH);
  return response.data.data;
};

const getGrowth = async (): Promise<DashboardGrowth> => {
  const response = await apiClient.get(GROWTH_PATH);
  return response.data.data;
};

const getProfile = async (): Promise<UserProfile | null> => {
  try {
    const response = await apiClient.get(PROFILE_PATH);
    const raw = response.data?.admin ?? response.data?.data ?? response.data;
    if (!raw) return null;
    const name = raw.name ?? raw.first_name ?? '';
    const parts = String(name).trim().split(/\s+/);
    return {
      id: raw.id ?? '',
      first_name: raw.first_name ?? parts[0] ?? 'Admin',
      last_name: raw.last_name ?? parts.slice(1).join(' ') ?? '',
      email: raw.email ?? '',
      role: raw.role?.name ?? raw.role ?? '',
    };
  } catch {
    return null;
  }
};

export const getDashboardData = async (): Promise<{
  metrics: DashboardMetrics;
  growth: DashboardGrowth;
  profile: UserProfile | null;
}> => {
  const [metricsResult, growthResult, profileResult] = await Promise.allSettled([
    getMetrics(),
    getGrowth(),
    getProfile(),
  ]);

  if (metricsResult.status === 'rejected') {

    throw metricsResult.reason;
  }
  if (growthResult.status === 'rejected') {

    throw growthResult.reason;
  }

  return {
    metrics: metricsResult.value,
    growth: growthResult.value,
    profile: profileResult.status === 'fulfilled' ? profileResult.value : null,
  };
};
